import { google } from "./axiosConfig";
import featureService from "./FeatureService";

export const GoogleAPI = {
  encode: async function (address) {
    var encoded = encodeURI(address);

    if (encoded === "") return;

    const response = await google.request({
      url: "json?address=" + encoded + "&key=" + featureService.mapKey(),
      method: "GET",
    });

    return response.data;
  },
};

export default GoogleAPI;
